import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import classes from './ServicePageLayout.module.scss';

const ServicePageLayout = ({ children }) => {
  return (
    <div className={classes.layout}>
      <Navbar />
      <main className={classes.main}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default ServicePageLayout;